import ListOptionsDropdownContainer from "./ListOptionsDropdownContainer";
import withListOptionsTracking from "./withListOptionsTracking";

/**
 * ListOptionsDropdownContainer component with tracking included
 */
export const ListOptionsDropdownTrackedContainer = withListOptionsTracking(ListOptionsDropdownContainer);
